// ── Stripe.js loader ─────────────────────────────────────────────────────────
//
// One shared promise for the whole app. loadStripe() injects a <script> tag, so
// calling it per component would fetch Stripe.js repeatedly and create several
// independent Stripe instances.
//
// WHY THE PUBLISHABLE KEY IS SAFE TO SHIP IN THE BUNDLE
// It is designed to be public — it can only create tokens and confirm intents
// the server already authorised. The SECRET key (sk_…) must never appear here.
// If you ever find a value starting `sk_` in this repo, it is a live incident:
// rotate it in the Stripe dashboard first, then remove it.
//
// WHY CARD ENTRY IS OPTIONAL RATHER THAN REQUIRED
// If the key is not configured the inline form cannot work, and the honest
// thing is to fall back to Stripe's hosted redirect rather than render a card
// form that will fail on submit. A missing environment variable should degrade
// the flow, not break it.

import { loadStripe } from '@stripe/stripe-js';

export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';

/** True when in-page card entry is available. */
export const isInlineCardEntryAvailable = () => Boolean(STRIPE_PUBLISHABLE_KEY);

let stripePromise = null;

export function getStripe() {
  if (!STRIPE_PUBLISHABLE_KEY) return null;
  if (!stripePromise) stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
  return stripePromise;
}

/**
 * Appearance for Stripe Elements, matched to the CMS palette.
 *
 * The fields render inside Stripe-hosted iframes — we can style them, but we
 * cannot read them, which is exactly the property that keeps card data out of
 * our JavaScript and therefore out of our error reporting and analytics.
 */
export const STRIPE_APPEARANCE = {
  theme: 'flat',
  variables: {
    colorPrimary: '#1C7C73',
    colorBackground: '#FFFFFF',
    colorText: '#1A1A1A',
    colorDanger: '#DC2626',
    fontFamily: 'Inter, system-ui, sans-serif',
    borderRadius: '10px',
    spacingUnit: '4px',
  },
  rules: {
    '.Input': { border: '1px solid #DDE0D8', boxShadow: 'none', padding: '12px' },
    '.Input:focus': { border: '1px solid #1C7C73', boxShadow: '0 0 0 3px rgba(28,124,115,0.12)' },
    '.Label': { fontWeight: '600', fontSize: '13px', color: '#5A5F55' },
  },
};
